import { useEffect, useState, useCallback } from "react";
import { Urls } from "../../../../Urls";
import axios from "../../../../Axios/Axios";

export const useFetchSimTracking = (indent_id) => {
  const [simTrackData, setSimTrackData] = useState(null);
  const [simErr, setSimErr] = useState(null);
  const [loadingSimTracking, setLoadingSimTracking] = useState(false);

  const fetchSimTracking = useCallback(async () => {
    if (!indent_id) {
      setSimTrackData(null);
      return;
    }

    setLoadingSimTracking(true);
    setSimErr(null);
    try {
      const uri = `${Urls.indentSimBased}?field=get_latest_location&indent_id=${indent_id}`;
      const { data } = await axios.get(uri);

      // handle internal errors
      if (data && data?.status === false) {
        console.log("SIM Tracking Error:", data?.message);
        setSimErr(data?.message || "Unable to fetch SIM tracking data.");
        setSimTrackData(null);
        return;
      }

      setSimTrackData(data);
      setSimErr(null);
    } catch (error) {
      console.error("Failed to fetch SIM tracking:", error);
      setSimErr("Something went wrong. Please try again later.");
      setSimTrackData(null);
    } finally {
      setLoadingSimTracking(false);
    }
  }, [indent_id]);

  useEffect(() => {
    fetchSimTracking();
  }, [fetchSimTracking]);

  return { fetchSimTracking, simTrackData, loadingSimTracking, simErr };
};
